export default __webpack_public_path__ + "static/media/pagination.b0ea9962.less";